module.exports = __webpack_public_path__ + "images/organization/new-team-member.3c5efeaa588ed35f8762.svg";